module.exports = "<div class=\"scroller-stage {{ theme | themeClass }}\" :style=\"{'max-height': maxHeight+'px', 'height': boxHeight+'px'}\"> <div v-el:scroller-box class=scroller-box> <slot></slot> </div> <div class=scroller-bar></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/base/scroller/scroller.tpl
// module id = 945
// module chunks = 2